/**
 *
 * @param {String} title
 * @param {Object} currentCategory
 */
export default function(title, currentCategory) {
  if (currentCategory?.title) {
    return `${title} / ${currentCategory?.title}`
  }
  return title
}
